// Salesforce Web-to-Case / complaints captcha_settings timestamp helper.
// Google’s snippet uses setInterval against captcha_settings; Turbolinks can
// navigate away while that interval is still running, which throws:
//   TypeError: can't access property "value", …[0] is undefined
// (Bugsnag 6ad030a6dbd69358a87734b6 on /contacts).

const INTERVAL_MS = 500

function captchaSettingsElement(doc) {
  return doc.getElementsByName('captcha_settings')[0] || null
}

/**
 * Refresh captcha_settings.ts while the reCAPTCHA response is empty.
 * Returns false when the settings field is missing so callers can stop.
 */
function tickCaptchaTimestamp(doc, nowFn) {
  const settings = captchaSettingsElement(doc)
  if (!settings) return false

  const response = doc.getElementById('g-recaptcha-response')
  if (response == null || String(response.value).trim() === '') {
    const elems = JSON.parse(settings.value)
    const now = typeof nowFn === 'function' ? nowFn() : Date.now()
    elems.ts = JSON.stringify(now)
    settings.value = JSON.stringify(elems)
  }

  return true
}

function createCaptchaTimestampController(doc, timers) {
  const setIntervalFn = (timers && timers.setInterval) || setInterval
  const clearIntervalFn = (timers && timers.clearInterval) || clearInterval
  let intervalId = null

  function stop() {
    if (intervalId != null) {
      clearIntervalFn(intervalId)
      intervalId = null
    }
  }

  function start() {
    stop()
    if (!captchaSettingsElement(doc)) return

    intervalId = setIntervalFn(function () {
      if (!tickCaptchaTimestamp(doc)) {
        stop()
      }
    }, INTERVAL_MS)
  }

  function bind() {
    doc.addEventListener('turbolinks:load', start)
    doc.addEventListener('turbolinks:before-cache', stop)
    doc.addEventListener('turbolinks:before-visit', stop)
    start()
  }

  return {
    start: start,
    stop: stop,
    bind: bind,
    isRunning: function () {
      return intervalId != null
    },
  }
}

function bindSalesforceCaptchaTimestamp(doc) {
  const controller = createCaptchaTimestampController(doc || document)
  controller.bind()
  return controller
}

if (typeof document !== 'undefined') {
  bindSalesforceCaptchaTimestamp(document)
}

module.exports = {
  INTERVAL_MS: INTERVAL_MS,
  tickCaptchaTimestamp: tickCaptchaTimestamp,
  createCaptchaTimestampController: createCaptchaTimestampController,
  bindSalesforceCaptchaTimestamp: bindSalesforceCaptchaTimestamp,
}
